export default __webpack_public_path__ + "static/media/herb-copy.b144c591.png";